.clickable {
  cursor: pointer;
  &:hover {
    background-color: var(--mantine-color-gray-0);
  }
}

.root {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 0;
  /* White card framed by the single prominent grid hairline (#a7a7a7), matching
     the app-shell rails and tables. */
  /* biome-ignore lint/complexity/noImportantStyles: Needed to override the default color */
  border-color: var(--mantine-color-default-border) !important;
  background-color: var(--mantine-color-body);
  transition: background-color 0.2s ease-in-out;
  padding: 0 6px 8px 6px;
}

.head {
  padding: var(--mantine-spacing-xs) 6px;
}

.title {
  flex-grow: 1;
}

.body {
  /* The root Card owns the single card border; the body is just the content
     region, so it carries no border of its own (avoids a doubled frame). */
  flex-grow: 1;
  background-color: var(--mantine-color-body);
  padding: var(--mantine-spacing-xs);
}
